import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { milestoneRequestsBackend } from './milestone-requests.backend';
import { milestoneRequestsReducer } from './milestone-requests.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('milestoneRequests', milestoneRequestsReducer),
    BackendModule.forFeature('milestoneRequests', milestoneRequestsBackend),
  ],
})
export class DatastoreMilestoneRequestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/milestone-requests/milestone-requests.module.ts